import { LOGOUT_RESPONSE } from '../constants'

const initialState = []

export default function reducer(state = initialState, action) {
  let loaderId = typeof action.getLoaderId === 'function'
    ? action.getLoaderId(action)
    : ''

  if (Array.isArray(loaderId)) {
    loaderId = loaderId.join('_')
  }

  if (action.type === LOGOUT_RESPONSE) {
    return initialState
  }

  if (action.type.match(/_REQUEST$/)) {
    const key = action.type.replace(/_REQUEST$/, `_${loaderId}`)
    if (!state.includes(key)) {
      return state.concat([key])
    }
    return state
  }

  if (action.type.match(/_RESPONSE$|_RESPONSE_ERROR$/)) {
    const key = action.type.replace(/_RESPONSE$|_RESPONSE_ERROR$/, `_${loaderId}`)
    return state.filter((k) => k !== key)
  }

  return state
}
